/**
 * 全局图片查看器组件
 * 用于在应用任何地方查看大图，不触发局部组件重渲染
 */
import React from 'react'
import { PhotoProvider, PhotoSlider } from 'react-photo-view'
import 'react-photo-view/dist/react-photo-view.css'
import { useAppStore } from '../../store/useAppStore'

export const GlobalImageViewer: React.FC = () => {
  const { viewerImage, isViewerOpen, closeViewer } = useAppStore()

  return (
    <div className="global-image-viewer">
      <PhotoProvider maskOpacity={0.8}>
        <PhotoSlider
          images={viewerImage ? [{ src: viewerImage, key: viewerImage }] : []}
          visible={isViewerOpen}
          onClose={closeViewer}
          maskOpacity={0.8}
          photoClassName="object-contain"
        />
      </PhotoProvider>
    </div>
  )
}
